import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-generate-echeancier-dialog",
  standalone: true,
  imports: [ButtonModule, DialogModule, TranslateModule],
  templateUrl: "./generate-echeancier-dialog.component.html",
  styleUrl: "./generate-echeancier-dialog.component.scss",
})
export class GenerateEcheancierDialogComponent {
  @Input() visible!: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() actionConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  hide() {
    this.visibleChange.emit(false);
  }

  generateEcheancier(withStatus: boolean) {
    this.actionConfirmed.emit(withStatus);
  }
}
